module.exports = __webpack_public_path__ + "img/zh3.a0ee6a9a.webp";